'use client';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { logError } from 'commons/logger';

class CMSComponentErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const { componentName, path } = this.props;
    logError(
      error,
      {
        component: 'CMSComponentErrorBoundary',
        cmsComponent: componentName,
        cmsPath: path,
      },
      { componentStack: info?.componentStack }
    );
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

CMSComponentErrorBoundary.propTypes = {
  children: PropTypes.node,
  componentName: PropTypes.string,
  path: PropTypes.string,
};

export default CMSComponentErrorBoundary;
